import StandardRestError from './Standard'

class ProjectExpiredError extends StandardRestError {
  static CODE = 'PROJECT_EXPIRED'

  constructor(message = 'Project has expired.', status = 402, body = {}) {
    super(message)
    this.status = status
    this.body = body
  }
}

export default ProjectExpiredError
